import * as Cookies from 'tiny-cookie'
import * as UAParser from 'ua-parser-js'
import $config from '@/config'
import router from '../../router'
import HashID from '@/helpers/hashid'

let checkSecurity = async (context, userParams) => {
  let pageSettings = context.rootGetters['page-settings/getCopy']
  let device = context.rootGetters['devices/getCopy']
  /*
  webcastId: null,
  eventPasswordEnabled: false,
  eventPassword: '',
  ipWhiteListEnabled: false,
  ipWhiteList: '',
  emailDomainWhiteListEnabled: false,
  emailDomainWhiteList: '',
  referrerDomainWhiteListEnabled: false,
  referrerDomainWhiteList: '',
  */

  if (pageSettings.ipWhiteListEnabled) {
    if (device) {
      let ipArray = pageSettings.ipWhiteList.replace(/\s/g, '').split(',')
      if (!_.includes(ipArray, device.ip)) {
        router.push('/403')
        return false
      }
    }
  }

  if (pageSettings.emailDomainWhiteListEnabled) {
    if (_.has(userParams, 'uid')) {
      let domainArray = pageSettings.emailDomainWhiteList
        .replace(/\s/g, '')
        .split(',')
      let userDomain = userParams.uid.replace(/.*@/, '')
      if (!_.includes(domainArray, userDomain)) {
        router.push('/403')
        return false
      }
    }
  }

  if (pageSettings.emailValidationEnabled) {
    if (!_.has(userParams, 'token')) {
      if (router.currentRoute.name != 'landing') {
        router.push('/403')
        return false
      }
    }
  }

  return true
}

export default {
  keepCopiesInStore: true,
  actions: {
    async initUser (context, params) {
      let initType = null

      await checkSecurity(context, params).then(res => {
        // console.log("security resolved");
        if (res === false) {
          params = null
          return null
        }
      })

      if (Cookies.get(params.webcastId)) {
        initType = 'cookie'
      } else if (!params.isAnonymous) {
        initType = 'registration'
      } else if (params.token) {
        initType = 'token'
      }

      if (!params.uid) {
        params.uid = HashID.generate()
      }

      switch (initType) {
        case 'cookie':
          let cookieId = Cookies.get(params.webcastId)
          return this.dispatch('registrations/get', cookieId)
            .then(user => {
              context.commit('setCurrent', user)
              return user
            })
            .catch(error => {
              console.log(error)
            })
          break
        case 'registration':
          /* Check user from store */
          params['device'] = context.rootGetters['devices/getCopy']
          if (!params.uid) {
            params['uid'] = params.info.uid
            params['name'] = params.info.name
            params['location'] = params.info.location
          }

          if (params.info.name) {
            params['name'] = params.info.name
          }

          return this.dispatch('registrations/create', params).then(user => {
            let pageSettings = context.rootGetters['page-settings/getCopy']
            if (!pageSettings.emailValidationEnabled) {
              console.log('Set cookie')
              Cookies.set(params.webcastId, user._id, {
                samesite: 'None',
                secure: true
              })
              context.commit('setCurrent', user._id)
              return user
            }
          })
          /*
          await this.dispatch('registrations/find', {query: {webcastId: params.webcastId, uid: params.uid}}).then((userList)=>{
            if(userList.data.length >= 1){
              return this.dispatch('registrations/patch', [userList.data[0]._id, params]).then((user)=>{
                Cookies.set(params.webcastId, user._id);
                context.commit("setCurrent", user._id);
                return user;
              });
            } else {
              if(!params.uid){
                params['uid'] = params.info.uid
                params['name'] = params.info.name
                params['location'] = params.info.location
              }
              return this.dispatch('registrations/create', params ).then((user)=>{
                console.log("registration created");
                Cookies.set(params.webcastId, user._id);
                context.commit("setCurrent", user._id);
                return user;
              });
            }
          });
          */
          break
        case 'token':
          let p = {
            sToken: params.token
          }
          return this.dispatch('registrations/create', p)
            .then(user => {
              if (user) {
                context.commit('setCurrent', user)
                return user
              } else {
                return null
              }
            })
            .catch(error => {
              console.log(error)
            })
      }
    },

    logout (context, webcastId) {
      Cookies.remove(webcastId)
      context.commit('clearCurrent')
    }
  }
}
